import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "truncate"
}


import Spinner from "./Spinner.vue";
import { getButtonStyle } from "@/utils/buttonStyle";


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkButton',
  props: {
    styleType: {},
    text: {},
    icon: {},
    iconPosition: {},
    pending: { type: Boolean },
    pendingText: {},
    disabled: { type: Boolean },
    to: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: props.to,
    disabled: props.disabled || props.pending,
    class: _normalizeClass([
      'text-md py-2 px-5 border font-regular rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-opacity-50 disabled:pointer-events-none flex items-center w-full',
      _unref(getButtonStyle)(props.styleType),
    ])
  }, {
    default: _withCtx(() => [
      (__props.pending)
        ? (_openBlock(), _createBlock(Spinner, {
            key: 0,
            horizontal: true,
            "custom-text": __props.pendingText
          }, null, 8, ["custom-text"]))
        : _createCommentVNode("", true),
      (__props.iconPosition === 'left' && __props.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: _normalizeClass('fas fa-' + __props.icon + ' mr-2')
          }, null, 2))
        : _createCommentVNode("", true),
      (!__props.pending)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.text), 1))
        : _createCommentVNode("", true),
      (__props.iconPosition !== 'left' && __props.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 3,
            class: _normalizeClass('fas fa-' + __props.icon + ' ml-2')
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to", "disabled", "class"]))
}
}

})